import { MappedClass, MappedProperty } from '@h5s/util-object';

@MappedClass()
export class IstatGenerationParameters {
  @MappedProperty()
  availableBeds: number;

  @MappedProperty()
  availableRooms: number;

  @MappedProperty()
  availableToilets: number;
}
